import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div``;

export const Info = styled.main`
  max-width: 1120px;
  margin: 24px auto;
  padding: 0 8px;
  display: flex;

  flex-direction: row;

  align-items: center;
  align-content: center;
  justify-content: center;

  svg {
    &:hover {
      color: ${shade(0.2, '#2c73e9')} !important;
      cursor: pointer;
    }
  }

  h1 {
    width: 100vw;
    margin-left: 8px;
    color: #2c73e9;
  }
`;

export const Filtro = styled.div`
  max-width: 1120px;
  margin: 24px auto;
  padding: 0 8px;

  display: flex;

  flex-direction: row;

  align-items: center;
  align-content: center;
  justify-content: center;

  div + div {
    margin-left: 24px;
  }

  .btn-div {
    button {
      display: flex;

      align-items: center;
      svg {
        margin-right: 8px;
      }
    }
  }
`;

export const Tabela = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  place-content: center;

  align-items: center;
  justify-items: center;
`;
